import type { Size } from './toPortInfo.tsx';

type CanvasBoundingBox = {
	x: number;
	y: number;
	width: number;
	height: number;
};

export const getBBoxCenter = (
	bBox: CanvasBoundingBox,
): {
	x: number;
	y: number;
} => {
	const { x, y, width, height } = bBox;

	return {
		x: x + width / 2,
		y: y + height / 2,
	};
};

export const unionBBox = (
	canvasBoundingBox: CanvasBoundingBox | undefined,
	bBox: SVGRect,
): CanvasBoundingBox => {
	if (!canvasBoundingBox) {
		return {
			x: bBox.x,
			y: bBox.y,
			width: bBox.width,
			height: bBox.height,
		};
	}

	const bottomRight = {
		x: Math.max(bBox.x + bBox.width, canvasBoundingBox.x + canvasBoundingBox.width),
		y: Math.max(bBox.y + bBox.height, canvasBoundingBox.y + canvasBoundingBox.height),
	};

	const topLeft = {
		x: Math.min(bBox.x, canvasBoundingBox.x),
		y: Math.min(bBox.y, canvasBoundingBox.y),
	};

	return {
		x: topLeft.x,
		y: topLeft.y,
		width: bottomRight.x - topLeft.x,
		height: bottomRight.y - topLeft.y,
	};
};

export const getCanvasBoundingBox = (bBoxes: DOMRect[]): CanvasBoundingBox | undefined => {
	if (bBoxes.length < 1) return undefined;
	return bBoxes.reduce(
		(acc: CanvasBoundingBox | undefined, item) => unionBBox(acc, item),
		undefined,
	);
};

export const expandBoundingBox = (
	{ x, y, width, height }: CanvasBoundingBox,
	padding: number,
): {
	x: number;
	y: number;
	width: number;
	height: number;
} => ({
	x: x - padding,
	y: y - padding,
	width: width + 2 * padding,
	height: height + 2 * padding,
});

/** Mockable function to get initial size */
export const getInitialSize = (): Size => ({
	width: 0,
	height: 0,
});
